(() => {
  const ALLOWED_EVENTS = new Set(["early_access_start", "early_access_signup", "b2b_inquiry_submit"]);
  const ALLOWED_SOURCES = new Set(["hero", "ami_section", "footer"]);
  const MAX_QUEUE = 12;
  // __REFLEX_GA4_TEST_PERMISSION is a QA-only override for unpublished validation.
  // Production visitors never set it.
  const script = document.currentScript || document.querySelector("script[data-ga4-measurement-id]");
  const measurementId = (script && script.getAttribute("data-ga4-measurement-id") || "").trim();

  const pending = Array.isArray(window.reflexGa4Queue) ? window.reflexGa4Queue.slice() : [];
  const store = [];
  const sent = new Set();
  let configured = false;
  let sending = false;

  const permission = () => {
    const test = window.__REFLEX_GA4_TEST_PERMISSION;
    if (test === "denied" || test === "unknown" || test === "allowed") return test;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== "function") return "unknown";
    try {
      return privacy.analyticsProcessingAllowed() ? "allowed" : "denied";
    } catch {
      return "unknown";
    }
  };

  const sanitize = (raw) => {
    const name = raw && raw.event;
    if (!ALLOWED_EVENTS.has(name)) return null;
    const params = {};
    const source = (raw.params && raw.params.signup_source) || raw.signup_source;
    if (ALLOWED_SOURCES.has(source)) params.signup_source = source;
    return { event: name, params };
  };

  const eventKey = (item) => item.event + ":" + (item.params.signup_source || "");

  const emit = (item) => {
    if (!sending || permission() !== "allowed") return;
    if (typeof window.gtag !== "function") return;
    const key = eventKey(item);
    if (sent.has(key)) return;
    sent.add(key);
    const params = Object.assign({}, item.params, { send_to: measurementId });
    window.gtag("event", item.event, params);
  };

  const flush = () => {
    if (!configured || !sending || permission() !== "allowed") return;
    while (store.length) emit(store.shift());
  };

  const enqueue = (raw) => {
    const item = sanitize(raw);
    if (!item) return store.length;
    const perm = permission();
    if (perm === "denied") return store.length;
    const key = eventKey(item);
    if (sent.has(key)) return store.length;
    if (store.some((row) => eventKey(row) === key)) return store.length;
    if (perm === "allowed" && configured && sending) {
      emit(item);
      return store.length;
    }
    if (store.length >= MAX_QUEUE) store.shift();
    Array.prototype.push.call(store, item);
    return store.length;
  };

  window.reflexGa4Queue = store;
  store.push = function pushEvent(raw) {
    enqueue(raw);
    return store.length;
  };

  const ensureGtagStub = () => {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== "function") {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
  };

  const initIfAllowed = () => {
    if (permission() !== "allowed") return;
    sending = true;
    if (configured) {
      flush();
      return;
    }
    if (!/^G-[A-Z0-9]+$/i.test(measurementId)) return;
    configured = true;
    ensureGtagStub();
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { anonymize_ip: true, send_page_view: true });
    const loader = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(measurementId);
    if (![...document.scripts].some((node) => node.src === loader)) {
      const tag = document.createElement("script");
      tag.async = true;
      tag.src = loader;
      document.head.appendChild(tag);
    }
    flush();
  };

  const applyConsent = () => {
    const perm = permission();
    if (perm === "allowed") {
      initIfAllowed();
      return;
    }
    if (perm === "denied") sending = false;
  };

  pending.forEach(enqueue);

  window.reflexGa4State = () => ({
    measurementId,
    configured,
    sending,
    permission: permission(),
    queueLength: store.length,
    sent: Array.from(sent),
  });

  window.reflexGa4SetTestPermission = (value) => {
    window.__REFLEX_GA4_TEST_PERMISSION = value;
    applyConsent();
  };

  if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => {
      applyConsent();
      document.addEventListener("visitorConsentCollected", applyConsent);
    });
    return;
  }
})();
